import { render, staticRenderFns } from "./LiveHistory.vue?vue&type=template&id=320f6824&"
import script from "./LiveHistory.vue?vue&type=script&lang=js&"
export * from "./LiveHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports